import type { FullName } from '~/core/types'

export const composeFullName = (fio: FullName, usePatronymic = true) => {
  const { surname, forename, patronymic } = fio

  return `${surname} ${forename} ${usePatronymic ? patronymic : ''}`.replace(/\s+/g, ' ').trim()
}
